/* src/app/admin/content-list/content-list.component.scss */
/*# sourceMappingURL=content-list.component-TU7WVA7A.css.map */
